import CalendarDay from '@/components/ezuro/workschedule/components/CalendarDay.vue';

export default {
  name: 'Calendar',
  props: {
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    section: {
      type: String
    }
  },
  components: {
    CalendarDay
  },
  computed: {
    weeks () {
      const data = {};

      for (const key in this.scheduleData.days) {
        const day = this.scheduleData.days[key];

        if (!data[day.week]) {
          data[day.week] = {};
        }

        data[day.week][day.weekday] = this.BasicHelper.cloneObject(day);
      }

      return data;
    },
    notesByDay () {
      const notes = [];

      for (const note of this.scheduleData.notes) {
        if (!notes[note.day]) {
          notes[note.day] = [];
        }

        for (const schedule of this.scheduleData.schedules) {
          if (schedule.id == note.schedule_id) {
            const departmentName = this.$store.getters.getParamFromConfig('company_departments', schedule.department_id, 'name', this.$i18n.locale);
            const divisionName = schedule.division_id ? this.$store.getters.getParamFromConfig('company_divisions', schedule.division_id, 'name', this.$i18n.locale) : null;

            notes[note.day].push(departmentName + ' - ' + (divisionName ? divisionName + ' - ' : '') + note.notes);
          }
        }
      }

      return notes;
    }
  },
  methods: {
    editRecord: function (record) {
      this.$emit('editRecord', record);
    },
    addRecord: function (data) {
      this.$emit('editRecord', data);
    },
    addNotes: function (sqlDay) {
      this.$emit('addNotes', sqlDay);
    }
  }
}
